export default __webpack_public_path__ + "3ea3fd723832f819165f105c21e9ec4d.png";